<template>
  <div id="app">
    <transition name="fade-in">
      <router-view v-if="ready"/>
    </transition>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import moment from 'moment'
import authService from '@/services/support/AuthService'
import cookiesService from '@/services/support/CookiesService'
import config from '@/config'
import { MessageError } from './components/generic/MessageHandling.vue'
import { removeJWTAccessToken, removeJWTRefreshToken } from './api'
import LogService from './services/support/LogService'

export default Vue.extend({
  data () {
    return {
      ready: false
    }
  },

  async created () {
    cookiesService.config('1d', '/', config.appDomain)
    if (cookiesService.get(config.jwtAccessTokenCookieName)) {
      try {
        await authService.initAuth()
      } catch (error) {
        removeJWTAccessToken()
        new MessageError({
          propsData: {
            title: 'Error de token de acceso.',
            message: '',
            delay: 10000,
            error: error } }).displayMessage()
        LogService.error('Error on init user on created app. ' + error)
      }
    } else if (cookiesService.get(config.refreshTokenCookieName)) {
      try {
        await authService.refreshToken(cookiesService.get(config.refreshTokenCookieName))
      } catch (error) {
        removeJWTRefreshToken()
        new MessageError({
          propsData: {
            title: 'Error de token de refresco.',
            message: '',
            delay: 10000,
            error: error } }).displayMessage()
        LogService.error('Error on init user by refresh token on created app. ' + error)
      }
    }
    this.ready = true
  },

  mounted () {
    moment.locale('es')
  }
})
</script>

<style lang="scss">
:root {
  --primary-color: #3498db;
  --primary-color-hover: #2f89c5;
  --topbar-height: 50px;
  --sidebar-width: 100%;
  --font-color: #333333;
  --font-color-hover: #6e6e6e;
  --sidebar-bg-color: #f7f7f7;
  --element-hover-bg-color: #f0f0f0;
  --element-hover-dark-bg-color: #d0d0d0;
  --warning-bg-color: #ffd65c;
  --warning-hover-bg-color: #ffc107;
  --tracking-status-inactive: #bee4c4;
}

@media (min-width: 576px) {
  :root {
    --sidebar-width: 447px;
  }
}

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#app {
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'Roboto', sans-serif;
  color: var(--font-color);
}

.fade-in-enter-active,
.fade-in-leave-active {
  transition: opacity 0.3s;
}
.fade-in-enter,
.fade-in-leave-to {
  opacity: 0;
}

.fade-enter-active, .fade-leave-active {
  transition: all 350ms;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}

.fade-in-left-enter-active,
.fade-in-left-leave-active {
  transition: transform 0.2s ease;
}
.fade-in-left-enter,
.fade-in-left-leave-to {
  transform: translateX(-100%);
}

.fade-in-right-enter-active,
.fade-in-right-leave-active {
  transition: transform 0.2s ease;
}
.fade-in-right-enter,
.fade-in-right-leave-to {
  transform: translateX(100%);
}

.scrollable {
  &::-webkit-scrollbar-track {
    background-color: #e0e0e0;
  }

  &::-webkit-scrollbar {
    width: 8px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #c4c4c4;
    border-radius: 3px;
  }
}

.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: 'Browse' !important;
}

.custom-file-input:lang(es) ~ .custom-file-label::after {
  content: 'Buscar' !important;
}
</style>
